import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const en = {
  header: {
    nav: {
      home: "HOME",
      strategic: "STRATEGIC CONSULTING",
      logistics: "LOGISTICS & TRANSPORT",
      services: "SERVICES",
      about: "ABOUT US",
      news: "NEWS",
      contact: "CONTACT",
    },
  },
  footer: {
    tagline: "Turning strategy into measurable performance — worldwide.",
    contactUs: "CONTACT US",
    explore: "EXPLORE",
    rights: "All rights reserved.",
    motto: "INVESTIGATE · PROTECT · SUPPORT",
    address: "a la brona de Darba 7\n6563 Mesocco\nCanton Grigioni, Switzerland",
    nav: {
      strategic: "Strategic Consulting",
      logistics: "Logistics & Transport",
      services: "Services",
      about: "About Us",
      contact: "Contact",
    },
    legal: "LEGAL",
    privacy: "Privacy Policy",
    cookies: "Cookie Policy",
    impressum: "Impressum",
  },
  home: {
    welcome: "WELCOME TO COMM42",
    titlePart1: "Turning strategy into",
    titleEm: "measurable performance",
    titlePart2: "— worldwide",
    subtitle: "We support individuals, companies and organizations that need strategic guidance to reach defined objectives.",
    getInfo: "GET INFORMATION",
    exploreServices: "EXPLORE SERVICES →",
    motto: "INVESTIGATE · PROTECT · SUPPORT",
    stats: { years: "Years", cases: "Cases", available: "Available", confidential: "Confidential" },
    overall: "OVERALL STRATEGY",
    overallTitle: "Strategy at the core of everything",
    overallDesc: "We support individuals, companies and organizations that need strategic guidance to reach defined objectives. Together we build the most effective path through analysis, planning and continuous monitoring of results.",
    contact: "CONTACT",
    pillars: {
      strategy: { title: "STRATEGIC PLANNING", desc: "We define the most effective strategy for your specific context and objective." },
      legal: { title: "LEGAL DETERMINATION", desc: "Legal structure and protection of interests across international jurisdictions." },
      investigation: { title: "INVESTIGATION", desc: "Risk analysis, in-depth investigations and protection of brands and patents." },
      logistics: { title: "LOGISTICS", desc: "Personal security, escort services and global customs connections." },
    },
    expertGuidance: "EXPERT STRATEGIC GUIDANCE",
    expertTitle: "Strategy is a team sport.",
    expertDesc: "We help you build consensus around your project — from the boardroom to operations. Every milestone is mapped, measured and reviewed.",
    guidance: {
      start: { title: "Start from scratch", desc: "Don't know where to start? Contact us for a free strategic overview session." },
      fix: { title: "Fix what's broken", desc: "Already have a structure but it's not working? We identify the issues and build the solution." },
      measure: { title: "Measure results", desc: "You can't improve what you don't measure. We monitor every milestone." },
    },
    expertise: "OUR EXPERTISE",
    expertiseTitle: "What We Do",
    expertiseDesc: "At COMM42, we support individuals, companies and organizations worldwide with integrated strategic services — from investigation and legal protection to digital reputation and international logistics.",
    expertiseItems: {
      investigation: { title: "Investigation", desc: "Risk analysis and in-depth digital investigations." },
      legal: { title: "Legal Strategy", desc: "International legal structure and interests protection." },
      logistics: { title: "Logistics", desc: "Personal security and global customs connections." },
      reputation: { title: "Web Reputation", desc: "Digital protection and online brand monitoring." },
    },
    ctaEyebrow: "START FROM SCRATCH",
    ctaTitle: "Don't know where to start? Let's talk.",
    ctaDesc: "Contact us for a free strategic overview session.",
    ctaBtn: "REQUEST CONSULTATION",
  },
  services: {
    eyebrow: "SERVICES",
    title: "360° protection, from digital to the road",
    subtitle: "We specialize in IT investigations, forensic analysis, digital reputation defense and private logistics — protecting your identity, your data and your interests worldwide.",
    getStarted: "GET STARTED NOW",
    contact: "CONTACT",
    items: {
      it: { title: "IT Investigations", desc: "In-depth digital investigations to uncover the truth hidden behind the data." },
      forensics: { title: "Digital Forensics", desc: "Forensic analysis of devices, networks and systems with certified methodologies." },
      reputation: { title: "Digital Reputation", desc: "We monitor, protect and enhance your online presence against any threat." },
      cyber: { title: "Cyber Security", desc: "Advanced measures to protect your digital assets and sensitive data." },
      personal: { title: "Personal Protection", desc: "Tailored protection plans for individuals, events and high-value properties." },
      tech: { title: "Advanced Technology", desc: "Surveillance, access control and real-time monitoring for complete security." },
    },
    ctaTitle: "Need a tailored protection plan?",
    ctaDesc: "Speak with our team for a confidential assessment.",
  },
  about: {
    eyebrow: "KNOW WHAT WE DO",
    title: "Let's build something great together",
    subtitle: "Partner with us for a journey marked by growth, sustainability, security and a stellar digital reputation. Comm42 — where your business vision becomes reality.",
    contact: "CONTACT",
    aboutEyebrow: "ABOUT US",
    aboutTitle: "An international group of specialists",
    aboutDesc: "Comm42 operates at the intersection of strategy, investigation, legal protection and private logistics. We work alongside individuals, executives and organizations worldwide — providing integrated, tailor-made solutions to protect their interests and achieve their objectives.",
    mission: { title: "Our Mission", desc: "Build a bridge between our clients' goals and the resources, expertise and connections required to reach them. We operate with absolute discretion, direct accountability and a results-driven approach — from the first consultation to the final outcome." },
    why: { title: "Why Comm42", desc: "We are not a traditional consultancy. Our team combines backgrounds in law enforcement, intelligence, international law and private security — a unique ability to handle complex, sensitive and cross-border situations that standard firms cannot." },
    valuesEyebrow: "OUR VALUES",
    valuesTitle: "The principles that guide every engagement",
    values: {
      discretion: { title: "Discretion", desc: "Every engagement is treated with absolute confidentiality." },
      precision: { title: "Precision", desc: "No generic solutions — every strategy is built around the client." },
      integrity: { title: "Integrity", desc: "We operate within legal and ethical boundaries at all times." },
      results: { title: "Results", desc: "We measure our success by our clients' outcomes." },
    },
    testimonialsEyebrow: "WHAT OUR CLIENTS SAY",
    testimonialsTitle: "Valued customer feedback",
    testimonials: {
      t1: { quote: "Working with Comm42 to relocate our business to Dubai was a game-changer. Their team made a daunting process smooth and manageable, with deep expertise in both markets.", role: "CEO" },
      t2: { quote: "Their innovative, tailored approach to our energy storage project significantly enhanced our operational efficiency. Managed professionally from start to finish.", role: "Director & Agent" },
      t3: { quote: "Their cyber security and digital reputation services delivered unparalleled peace of mind. A proactive partner that protects and elevates our digital footprint.", role: "Client & Agent" },
    },
    statsEyebrow: "OUR ACHIEVEMENTS",
    statsTitle: "Numbers that speak for themselves",
    stats: { projects: "Successful Projects", consultations: "Consultations", achievements: "Professional Achievements", clients: "Clients Worldwide" },
    ctaTitle: "Turning strategy into measurable performance — worldwide",
    ctaDesc: "Talk to our team for a confidential, personalized assessment.",
  },
  strategic: {
    eyebrow: "STRATEGIC CONSULTING",
    title: "We build the right strategy to achieve your goals",
    subtitle: "From analysis to execution — a structured methodology built on ten years of international practice.",
    items: {
      legal: { title: "Strategic Legal Determination", desc: "Define the legal framework that protects your interests and supports your decisions across jurisdictions." },
      risk: { title: "Investigation & Risk Analysis", desc: "Identify hidden risks before they materialize. Data-driven analysis with verified sources." },
      web: { title: "Web Reputation & Digital Protection", desc: "Monitor, defend and rebuild your online reputation across markets." },
      logistics: { title: "International Logistics & Security", desc: "End-to-end coordination of secure logistics, escort and customs services." },
    },
    expertEyebrow: "EXPERT GUIDANCE",
    expertTitle: "Strategy is a team sport.",
    expertDesc: "We help you build consensus around your project — from the boardroom to operations. Every milestone is mapped, measured and reviewed.",
    bullets: {
      a: "Start from scratch — free strategic overview",
      b: "Fix what's broken — diagnose and rebuild",
      c: "Measure results — monitor every milestone",
    },
    legalEyebrow: "LEGAL DETERMINATION",
    legalTitle: "International jurisdictions, one trusted partner.",
    legalDesc: "Our network of legal advisors spans Europe, the Americas and Asia. We coordinate cross-border issues so you can focus on growth.",
    discuss: "DISCUSS YOUR CASE",
  },
  logistics: {
    eyebrow: "LOGISTICS & TRANSPORT",
    title: "Safe, discreet and reliable mobility — worldwide",
    subtitle: "High-level logistics and transport for individuals, executives and organizations. From VIP airport transfers to international escort convoys.",
    introEyebrow: "INTERNATIONAL LOGISTICS & SECURITY",
    introTitle: "Every movement, managed with care.",
    introDesc: "We provide high-level logistics and transport solutions for individuals, executives and organizations. From VIP airport transfers to international escort convoys — every movement is managed with maximum security and absolute discretion.",
    request: "REQUEST A SERVICE",
    safetyEyebrow: "PERSONAL SAFETY",
    safetyTitle: "Trained drivers, total discretion.",
    safety: {
      personal: { title: "Personal safety", desc: "Drivers trained in close protection and risk management." },
      conf: { title: "Absolute confidentiality", desc: "Total discretion on routes, schedules, and passengers." },
    },
    clientsEyebrow: "WHEN CLIENTS CALL US",
    clientsTitle: "Coordinated mobility for what matters most.",
    clients: {
      exec: { title: "Executive & business", desc: "Professional travel with guaranteed punctuality." },
      vip: { title: "Families & VIPs", desc: "Private logistics for those who matter most." },
      sensitive: { title: "Sensitive transfers", desc: "Planned routes, ready alternatives, security coordination." },
    },
    ctaTitle: "Plan your next movement with us.",
    ctaDesc: "Contact our team to coordinate a transfer, escort or international convoy.",
    contact: "CONTACT",
  },
  contact: {
    eyebrow: "GET IN TOUCH",
    title: "Get in touch with us",
    subtitle: "Taking your business to the global stage, integrating sustainable solutions, fortifying cyber security and managing digital reputation — Comm42 helps you navigate complex challenges with clarity and expertise.",
    infoEyebrow: "CONTACT US",
    infoTitle: "Let's start a conversation",
    infoDesc: "Tell us about your project, your concerns or your goals. Our team will get back to you within one business day.",
    address: "OFFICE ADDRESS",
    addressLines: "a la brona de Darba 7\n6563 Mesocco (GR)\nCanton Grigioni, Switzerland",
    mailUs: "MAIL US",
    callUs: "CALL US",
    ourServices: "OUR SERVICES",
    formTitle: "Send us a message",
    formDesc: "We treat every inquiry with discretion.",
    name: "NAME",
    email: "EMAIL",
    company: "COMPANY",
    message: "MESSAGE",
    send: "SEND MESSAGE",
    submitted: "Message sent successfully. Thank you for reaching out.",
    findUs: "FIND US",
    findTitle: "Mesocco, Switzerland",
  },
  notFound: {
    title: "Page not found",
    desc: "The page you're looking for doesn't exist or has been moved.",
    home: "Go home",
  },
  error: {
    title: "This page didn't load",
    desc: "Something went wrong on our end. You can try refreshing or head back home.",
    retry: "Try again",
    home: "Go home",
  },
  seo: {
    home: {
      title: "Comm42 SA — Turning strategy into measurable performance",
      description: "Strategic consulting, legal determination, investigation, and international logistics. Worldwide partner for individuals, companies and organizations.",
      ogTitle: "Comm42 SA — Strategy that performs, worldwide",
      ogDescription: "Investigate · Protect · Support. We build the right strategy to achieve your goals.",
    },
    services: {
      title: "Services — Comm42 SA",
      description: "IT investigations, digital forensics, cyber security, personal protection and advanced surveillance technology.",
      ogTitle: "Services — 360° protection from digital to the road",
      ogDescription: "We protect your identity, your data and your interests worldwide.",
    },
    about: {
      title: "About Us — Comm42 SA",
      description: "An international group of specialists in strategy, investigation, legal protection and private logistics.",
      ogTitle: "About Comm42 — Let's build something great together",
      ogDescription: "Partner with us for growth, security and a stellar digital reputation.",
    },
    strategic: {
      title: "Strategic Consulting — Comm42 SA",
      description: "Strategic guidance, legal determination and risk analysis for individuals, companies and organizations worldwide.",
      ogTitle: "Strategic Consulting — Comm42 SA",
      ogDescription: "We build the right strategy to achieve your goals.",
    },
    logistics: {
      title: "Logistics & Transport — Comm42 SA",
      description: "High-level logistics and transport for individuals, executives and organizations. VIP transfers and international escort.",
      ogTitle: "Logistics & Transport — Safe, discreet, worldwide",
      ogDescription: "Every movement managed with maximum security and absolute discretion.",
    },
    contact: {
      title: "Contact — Comm42 SA",
      description: "Get in touch with Comm42 for strategy, security, logistics and legal protection. Offices in Mesocco, Switzerland.",
      ogTitle: "Contact — Comm42 SA",
      ogDescription: "Talk to Comm42 about your next move — global strategy, cyber security and private logistics.",
    },
  },
  news: {
    eyebrow: "NEWS & INSIGHTS",
    title: "News, analysis and editorial plan",
    subtitle: "Articles, market insights and field updates from the Comm42 team — strategy, investigation, legal protection and international logistics.",
    loading: "Loading…",
    empty: "No articles published yet. Come back soon.",
    back: "Back to news",
  },
  auth: {
    loginTitle: "Sign in",
    signupTitle: "Create account",
    subtitle: "Editorial area reserved to Comm42 staff.",
    password: "Password",
    loginBtn: "Sign in",
    signupBtn: "Create account",
    toSignup: "No account? Create one",
    toLogin: "Already have an account? Sign in",
    loginOk: "Welcome back.",
    signupOk: "Check your email to confirm your account.",
  },
  admin: {
    eyebrow: "EDITORIAL AREA",
    title: "Manage news",
    new: "New article",
    logout: "Sign out",
    empty: "No articles yet. Click \"New article\" to start.",
    noRole: "Your account has no editor role. Ask an administrator to grant you the editor or admin role from the Backend.",
    saved: "Article saved.",
    deleted: "Article deleted.",
    save: "Save",
    cancel: "Cancel",
    confirmDelete: "Delete this article? This action cannot be undone.",
    editArticle: "Edit article",
    newArticle: "New article",
    f: {
      title: "Title",
      slug: "Slug (URL)",
      language: "Language",
      published: "Published",
      cover: "Cover image URL",
      excerpt: "Excerpt",
      content: "Content",
      contentHint: "Plain text. Line breaks are preserved.",
    },
  },
};

export const it: typeof en = {
  header: {
    nav: {
      home: "HOME",
      strategic: "CONSULENZA STRATEGICA",
      logistics: "LOGISTICA E TRASPORTI",
      services: "SERVIZI",
      about: "CHI SIAMO",
      news: "NEWS",
      contact: "CONTATTI",
    },
  },
  footer: {
    tagline: "Trasformiamo la strategia in performance misurabili — in tutto il mondo.",
    contactUs: "CONTATTACI",
    explore: "ESPLORA",
    rights: "Tutti i diritti riservati.",
    motto: "INDAGARE · PROTEGGERE · SUPPORTARE",
    address: "a la brona de Darba 7\n6563 Mesocco\nCanton Grigioni, Svizzera",
    nav: {
      strategic: "Consulenza Strategica",
      logistics: "Logistica e Trasporti",
      services: "Servizi",
      about: "Chi Siamo",
      contact: "Contatti",
    },
    legal: "LEGALE",
    privacy: "Privacy Policy",
    cookies: "Cookie Policy",
    impressum: "Impressum",
  },
  home: {
    welcome: "BENVENUTI IN COMM42",
    titlePart1: "Trasformiamo la strategia in",
    titleEm: "performance misurabili",
    titlePart2: "— in tutto il mondo",
    subtitle: "Affianchiamo persone, aziende e organizzazioni che hanno bisogno di una guida strategica per raggiungere obiettivi definiti.",
    getInfo: "RICHIEDI INFORMAZIONI",
    exploreServices: "SCOPRI I SERVIZI →",
    motto: "INDAGARE · PROTEGGERE · SUPPORTARE",
    stats: { years: "Anni", cases: "Casi", available: "Disponibili", confidential: "Riservato" },
    overall: "STRATEGIA COMPLESSIVA",
    overallTitle: "La strategia al centro di tutto",
    overallDesc: "Affianchiamo persone, aziende e organizzazioni che hanno bisogno di una guida strategica per raggiungere obiettivi definiti. Insieme costruiamo il percorso più efficace attraverso analisi, pianificazione e monitoraggio continuo dei risultati.",
    contact: "CONTATTI",
    pillars: {
      strategy: { title: "PIANIFICAZIONE STRATEGICA", desc: "Definiamo la strategia più efficace per il tuo contesto e obiettivo specifico." },
      legal: { title: "DETERMINAZIONE LEGALE", desc: "Struttura legale e tutela degli interessi nelle giurisdizioni internazionali." },
      investigation: { title: "INVESTIGAZIONE", desc: "Analisi del rischio, indagini approfondite e tutela di marchi e brevetti." },
      logistics: { title: "LOGISTICA", desc: "Sicurezza personale, servizi di scorta e collegamenti doganali globali." },
    },
    expertGuidance: "GUIDA STRATEGICA ESPERTA",
    expertTitle: "La strategia è un gioco di squadra.",
    expertDesc: "Ti aiutiamo a costruire consenso attorno al tuo progetto — dalla sala riunioni alle operazioni. Ogni traguardo è mappato, misurato e rivisto.",
    guidance: {
      start: { title: "Partire da zero", desc: "Non sai da dove iniziare? Contattaci per una sessione strategica gratuita." },
      fix: { title: "Sistemare ciò che non funziona", desc: "Hai già una struttura ma non funziona? Identifichiamo i problemi e costruiamo la soluzione." },
      measure: { title: "Misurare i risultati", desc: "Non puoi migliorare ciò che non misuri. Monitoriamo ogni traguardo." },
    },
    expertise: "LE NOSTRE COMPETENZE",
    expertiseTitle: "Cosa Facciamo",
    expertiseDesc: "In COMM42 supportiamo persone, aziende e organizzazioni nel mondo con servizi strategici integrati — dall'investigazione alla protezione legale, dalla reputazione digitale alla logistica internazionale.",
    expertiseItems: {
      investigation: { title: "Investigazione", desc: "Analisi del rischio e indagini digitali approfondite." },
      legal: { title: "Strategia Legale", desc: "Struttura legale internazionale e tutela degli interessi." },
      logistics: { title: "Logistica", desc: "Sicurezza personale e collegamenti doganali globali." },
      reputation: { title: "Reputazione Web", desc: "Protezione digitale e monitoraggio del brand online." },
    },
    ctaEyebrow: "PARTIRE DA ZERO",
    ctaTitle: "Non sai da dove iniziare? Parliamone.",
    ctaDesc: "Contattaci per una sessione strategica gratuita.",
    ctaBtn: "RICHIEDI CONSULENZA",
  },
  services: {
    eyebrow: "SERVIZI",
    title: "Protezione a 360°, dal digitale alla strada",
    subtitle: "Siamo specializzati in indagini IT, analisi forense, difesa della reputazione digitale e logistica privata — tuteliamo la tua identità, i tuoi dati e i tuoi interessi nel mondo.",
    getStarted: "INIZIA ORA",
    contact: "CONTATTI",
    items: {
      it: { title: "Indagini IT", desc: "Indagini digitali approfondite per scoprire la verità nascosta dietro i dati." },
      forensics: { title: "Digital Forensics", desc: "Analisi forense di dispositivi, reti e sistemi con metodologie certificate." },
      reputation: { title: "Reputazione Digitale", desc: "Monitoriamo, proteggiamo e valorizziamo la tua presenza online da ogni minaccia." },
      cyber: { title: "Cyber Security", desc: "Misure avanzate per proteggere asset digitali e dati sensibili." },
      personal: { title: "Protezione Personale", desc: "Piani di protezione su misura per persone, eventi e proprietà di valore." },
      tech: { title: "Tecnologia Avanzata", desc: "Sorveglianza, controllo accessi e monitoraggio in tempo reale per una sicurezza completa." },
    },
    ctaTitle: "Hai bisogno di un piano di protezione su misura?",
    ctaDesc: "Parla con il nostro team per una valutazione riservata.",
  },
  about: {
    eyebrow: "SCOPRI COSA FACCIAMO",
    title: "Costruiamo insieme qualcosa di grande",
    subtitle: "Collabora con noi per un percorso fatto di crescita, sostenibilità, sicurezza e una reputazione digitale impeccabile. Comm42 — dove la tua visione di business diventa realtà.",
    contact: "CONTATTI",
    aboutEyebrow: "CHI SIAMO",
    aboutTitle: "Un gruppo internazionale di specialisti",
    aboutDesc: "Comm42 opera all'incrocio tra strategia, investigazione, protezione legale e logistica privata. Lavoriamo al fianco di persone, dirigenti e organizzazioni nel mondo — offrendo soluzioni integrate e su misura per tutelare i loro interessi e raggiungere gli obiettivi.",
    mission: { title: "La Nostra Missione", desc: "Costruire un ponte tra gli obiettivi dei nostri clienti e le risorse, le competenze e i contatti necessari per raggiungerli. Operiamo con assoluta discrezione, responsabilità diretta e un approccio orientato ai risultati — dalla prima consulenza al risultato finale." },
    why: { title: "Perché Comm42", desc: "Non siamo una consulenza tradizionale. Il nostro team unisce esperienze in forze dell'ordine, intelligence, diritto internazionale e sicurezza privata — una capacità unica di gestire situazioni complesse, sensibili e transfrontaliere che le aziende standard non possono affrontare." },
    valuesEyebrow: "I NOSTRI VALORI",
    valuesTitle: "I principi che guidano ogni incarico",
    values: {
      discretion: { title: "Discrezione", desc: "Ogni incarico è trattato con assoluta riservatezza." },
      precision: { title: "Precisione", desc: "Niente soluzioni generiche — ogni strategia è costruita sul cliente." },
      integrity: { title: "Integrità", desc: "Operiamo sempre nel rispetto dei limiti legali ed etici." },
      results: { title: "Risultati", desc: "Misuriamo il nostro successo dai risultati dei clienti." },
    },
    testimonialsEyebrow: "COSA DICONO I CLIENTI",
    testimonialsTitle: "Feedback dei nostri clienti",
    testimonials: {
      t1: { quote: "Lavorare con Comm42 per trasferire la nostra attività a Dubai è stato decisivo. Il loro team ha reso un processo complesso fluido e gestibile, con grande esperienza in entrambi i mercati.", role: "CEO" },
      t2: { quote: "Il loro approccio innovativo e su misura al nostro progetto di accumulo energetico ha migliorato significativamente l'efficienza operativa. Gestito con professionalità dall'inizio alla fine.", role: "Direttore & Agente" },
      t3: { quote: "I servizi di cyber security e reputazione digitale ci hanno garantito una tranquillità senza pari. Un partner proattivo che protegge e valorizza la nostra impronta digitale.", role: "Cliente & Agente" },
    },
    statsEyebrow: "I NOSTRI RISULTATI",
    statsTitle: "Numeri che parlano da soli",
    stats: { projects: "Progetti completati", consultations: "Consulenze", achievements: "Traguardi professionali", clients: "Clienti nel mondo" },
    ctaTitle: "Trasformiamo la strategia in performance misurabili — nel mondo",
    ctaDesc: "Parla con il nostro team per una valutazione riservata e personalizzata.",
  },
  strategic: {
    eyebrow: "CONSULENZA STRATEGICA",
    title: "Costruiamo la strategia giusta per raggiungere i tuoi obiettivi",
    subtitle: "Dall'analisi all'esecuzione — una metodologia strutturata su dieci anni di pratica internazionale.",
    items: {
      legal: { title: "Determinazione Legale Strategica", desc: "Definiamo il quadro giuridico che tutela i tuoi interessi e supporta le tue decisioni nelle varie giurisdizioni." },
      risk: { title: "Investigazione e Analisi del Rischio", desc: "Individuiamo i rischi nascosti prima che si manifestino. Analisi data-driven con fonti verificate." },
      web: { title: "Reputazione Web e Protezione Digitale", desc: "Monitoriamo, difendiamo e ricostruiamo la tua reputazione online sui mercati." },
      logistics: { title: "Logistica e Sicurezza Internazionale", desc: "Coordinamento end-to-end di logistica sicura, scorta e servizi doganali." },
    },
    expertEyebrow: "GUIDA ESPERTA",
    expertTitle: "La strategia è un gioco di squadra.",
    expertDesc: "Ti aiutiamo a costruire consenso attorno al tuo progetto — dalla sala riunioni alle operazioni. Ogni traguardo è mappato, misurato e rivisto.",
    bullets: {
      a: "Partire da zero — overview strategica gratuita",
      b: "Sistemare ciò che non funziona — diagnosi e ricostruzione",
      c: "Misurare i risultati — monitoriamo ogni traguardo",
    },
    legalEyebrow: "DETERMINAZIONE LEGALE",
    legalTitle: "Giurisdizioni internazionali, un unico partner di fiducia.",
    legalDesc: "La nostra rete di consulenti legali copre Europa, Americhe e Asia. Coordiniamo le questioni transfrontaliere così tu puoi concentrarti sulla crescita.",
    discuss: "DISCUTI IL TUO CASO",
  },
  logistics: {
    eyebrow: "LOGISTICA E TRASPORTI",
    title: "Mobilità sicura, discreta e affidabile — nel mondo",
    subtitle: "Logistica e trasporti di alto livello per persone, dirigenti e organizzazioni. Dai trasferimenti VIP da/per l'aeroporto ai convogli di scorta internazionali.",
    introEyebrow: "LOGISTICA E SICUREZZA INTERNAZIONALE",
    introTitle: "Ogni spostamento, gestito con cura.",
    introDesc: "Forniamo soluzioni di logistica e trasporto di alto livello per persone, dirigenti e organizzazioni. Dai trasferimenti VIP ai convogli di scorta internazionali — ogni spostamento è gestito con la massima sicurezza e assoluta discrezione.",
    request: "RICHIEDI UN SERVIZIO",
    safetyEyebrow: "SICUREZZA PERSONALE",
    safetyTitle: "Autisti formati, totale discrezione.",
    safety: {
      personal: { title: "Sicurezza personale", desc: "Autisti formati in protezione ravvicinata e gestione del rischio." },
      conf: { title: "Riservatezza assoluta", desc: "Totale discrezione su percorsi, orari e passeggeri." },
    },
    clientsEyebrow: "QUANDO I CLIENTI CI CHIAMANO",
    clientsTitle: "Mobilità coordinata per ciò che conta di più.",
    clients: {
      exec: { title: "Executive & business", desc: "Viaggi professionali con puntualità garantita." },
      vip: { title: "Famiglie e VIP", desc: "Logistica privata per chi conta di più." },
      sensitive: { title: "Trasferimenti sensibili", desc: "Percorsi pianificati, alternative pronte, coordinamento di sicurezza." },
    },
    ctaTitle: "Pianifica con noi il tuo prossimo spostamento.",
    ctaDesc: "Contatta il nostro team per coordinare un transfer, una scorta o un convoglio internazionale.",
    contact: "CONTATTI",
  },
  contact: {
    eyebrow: "METTITI IN CONTATTO",
    title: "Mettiti in contatto con noi",
    subtitle: "Portare il tuo business sulla scena globale, integrare soluzioni sostenibili, rafforzare la cyber security e gestire la reputazione digitale — Comm42 ti aiuta a navigare sfide complesse con chiarezza ed esperienza.",
    infoEyebrow: "CONTATTACI",
    infoTitle: "Iniziamo una conversazione",
    infoDesc: "Raccontaci il tuo progetto, le tue preoccupazioni o i tuoi obiettivi. Il nostro team ti risponderà entro un giorno lavorativo.",
    address: "INDIRIZZO UFFICIO",
    addressLines: "a la brona de Darba 7\n6563 Mesocco (GR)\nCanton Grigioni, Svizzera",
    mailUs: "SCRIVICI",
    callUs: "CHIAMACI",
    ourServices: "I NOSTRI SERVIZI",
    formTitle: "Inviaci un messaggio",
    formDesc: "Trattiamo ogni richiesta con discrezione.",
    name: "NOME",
    email: "EMAIL",
    company: "AZIENDA",
    message: "MESSAGGIO",
    send: "INVIA MESSAGGIO",
    submitted: "Messaggio inviato correttamente. Grazie per averci contattato.",
    findUs: "DOVE SIAMO",
    findTitle: "Mesocco, Svizzera",
  },
  notFound: {
    title: "Pagina non trovata",
    desc: "La pagina che stai cercando non esiste o è stata spostata.",
    home: "Torna alla home",
  },
  error: {
    title: "Questa pagina non si è caricata",
    desc: "Qualcosa è andato storto da parte nostra. Puoi riprovare o tornare alla home.",
    retry: "Riprova",
    home: "Torna alla home",
  },
  seo: {
    home: {
      title: "Comm42 SA — Trasformiamo la strategia in performance misurabili",
      description: "Consulenza strategica, determinazione legale, investigazione e logistica internazionale. Partner globale per persone, aziende e organizzazioni.",
      ogTitle: "Comm42 SA — Strategia che produce risultati, nel mondo",
      ogDescription: "Indagare · Proteggere · Supportare. Costruiamo la strategia giusta per i tuoi obiettivi.",
    },
    services: {
      title: "Servizi — Comm42 SA",
      description: "Indagini IT, digital forensics, cyber security, protezione personale e tecnologie di sorveglianza avanzata.",
      ogTitle: "Servizi — Protezione a 360° dal digitale alla strada",
      ogDescription: "Tuteliamo la tua identità, i tuoi dati e i tuoi interessi nel mondo.",
    },
    about: {
      title: "Chi Siamo — Comm42 SA",
      description: "Un gruppo internazionale di specialisti in strategia, investigazione, protezione legale e logistica privata.",
      ogTitle: "Chi Siamo — Costruiamo insieme qualcosa di grande",
      ogDescription: "Collabora con noi per crescita, sicurezza e una reputazione digitale impeccabile.",
    },
    strategic: {
      title: "Consulenza Strategica — Comm42 SA",
      description: "Guida strategica, determinazione legale e analisi del rischio per persone, aziende e organizzazioni nel mondo.",
      ogTitle: "Consulenza Strategica — Comm42 SA",
      ogDescription: "Costruiamo la strategia giusta per raggiungere i tuoi obiettivi.",
    },
    logistics: {
      title: "Logistica e Trasporti — Comm42 SA",
      description: "Logistica e trasporti di alto livello per persone, dirigenti e organizzazioni. Transfer VIP e scorte internazionali.",
      ogTitle: "Logistica e Trasporti — Sicura, discreta, nel mondo",
      ogDescription: "Ogni spostamento gestito con la massima sicurezza e assoluta discrezione.",
    },
    contact: {
      title: "Contatti — Comm42 SA",
      description: "Mettiti in contatto con Comm42 per strategia, sicurezza, logistica e protezione legale. Uffici a Mesocco, Svizzera.",
      ogTitle: "Contatti — Comm42 SA",
      ogDescription: "Parla con Comm42 della tua prossima mossa — strategia globale, cyber security e logistica privata.",
    },
  },
  news: {
    eyebrow: "NEWS E APPROFONDIMENTI",
    title: "News, analisi e piano editoriale",
    subtitle: "Articoli, insight di mercato e aggiornamenti dal team Comm42 — strategia, indagini, protezione legale e logistica internazionale.",
    loading: "Caricamento…",
    empty: "Nessun articolo pubblicato. Torna presto.",
    back: "Torna alle news",
  },
  auth: {
    loginTitle: "Accedi",
    signupTitle: "Crea account",
    subtitle: "Area editoriale riservata allo staff Comm42.",
    password: "Password",
    loginBtn: "Accedi",
    signupBtn: "Crea account",
    toSignup: "Non hai un account? Crealo",
    toLogin: "Hai già un account? Accedi",
    loginOk: "Bentornato.",
    signupOk: "Controlla la mail per confermare l'account.",
  },
  admin: {
    eyebrow: "AREA EDITORIALE",
    title: "Gestione news",
    new: "Nuovo articolo",
    logout: "Esci",
    empty: "Nessun articolo. Clicca \"Nuovo articolo\" per iniziare.",
    noRole: "Il tuo account non ha il ruolo editor. Chiedi a un amministratore di assegnarti il ruolo editor o admin dal Backend.",
    saved: "Articolo salvato.",
    deleted: "Articolo eliminato.",
    save: "Salva",
    cancel: "Annulla",
    confirmDelete: "Eliminare questo articolo? L'azione è irreversibile.",
    editArticle: "Modifica articolo",
    newArticle: "Nuovo articolo",
    f: {
      title: "Titolo",
      slug: "Slug (URL)",
      language: "Lingua",
      published: "Pubblicato",
      cover: "URL immagine di copertina",
      excerpt: "Estratto",
      content: "Contenuto",
      contentHint: "Testo semplice. Le interruzioni di riga sono conservate.",
    },
  },
};

const STORAGE_KEY = "comm42-lang";

function getClientPreferredLang(): "en" | "it" {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === "en" || saved === "it") return saved;
    const nav = (window.navigator.language || "en").toLowerCase();
    return nav.startsWith("it") ? "it" : "en";
  } catch {
    return "en";
  }
}

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: { en: { translation: en }, it: { translation: it } },
    lng: "en",
    fallbackLng: "en",
    initAsync: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
}

export function syncLanguageWithClientPreference() {
  if (typeof window === "undefined") return;
  const preferred = getClientPreferredLang();
  if (!i18n.language?.startsWith(preferred)) {
    i18n.changeLanguage(preferred);
  }
}

export function setLanguage(lang: "en" | "it") {
  i18n.changeLanguage(lang);
  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      // ignore
    }
  }
}

export default i18n;